import { HIGHLIGHT_METRIC, HIGHLIGHT_TAG_MAP, MetricsDetailItem } from '../../../../model/caf.interface'
import useRNMsg, { ringleAppNavs } from '../../../../modules/hooks/webview/common/useRNMsg'

import { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useHtmlParserTransform from '../../../../modules/hooks/webview/caf/common/useHtmlParserTransform'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { ICON_ALARM_GRAY } from '../../../../modules/svg/svg'
import ErrorReportPopupComponent from '../../../student/portal/lessons/caf/CAFOverview/popup/CafErrorReportPopup'
import Accordion from '../common/Accordion'
import AudioController from '../common/AudioController'
import AIParaphraseButton from './AIParaphraseButton'
import AccordionContainer from './AccordionContainer'
import AccordionTitle from './AccordionTitle'

const HighlightDetailListAI = ({ details, tag }) => {
  const { t } = useTranslation()
  const { sendPostMsg } = useRNMsg()
  const { transformHTMLNode } = useHtmlParserTransform()
  const [sentenceToReport, setSentenceToReport] = useState('')
  const [showPopup, setShowPopup] = useState(false)
  const isMobile = useIsMobile()
  const handleClickErrorReport = (hilightId, content) => () => {
    if (isMobile) {
      sendPostMsg({
        nav: ringleAppNavs.cafErrorReport,
        detail_id: hilightId,
        detail_content: content,
        from: 'highlight',
      })
    } else {
      setSentenceToReport(content)
      setShowPopup(true)
    }
  }

  const isEnabledAIParaphrase =
    +tag === HIGHLIGHT_TAG_MAP.ros ||
    +tag === HIGHLIGHT_TAG_MAP.repetition ||
    +tag === HIGHLIGHT_TAG_MAP.sentence_structure

  const type = (+tag === 13 ? 'repetition' : +tag === 14 ? 'runon' : +tag === 17 ? 'sentence_structure' : '') as
    | HIGHLIGHT_METRIC
    | ''

  const CONTENT_MAP = {
    [HIGHLIGHT_TAG_MAP.ros]: () => null,
    [HIGHLIGHT_TAG_MAP.repetition]: (sentence) => (
      <p className="text-sBody mb-[16px] rounded bg-gray-50 p-[8px] text-[14px] tracking-tight ">
        {ReactHtmlParser(sentence, { transform: transformHTMLNode })}
      </p>
    ),
    [HIGHLIGHT_TAG_MAP.sentence_structure]: (content, index) => (
      <AccordionTitle type={type} content={content} index={index + 1} tag={tag} />
    ),
  }

  const getContent = CONTENT_MAP[tag]

  console.log(details, 'details')
  if (!details) return <></>
  return (
    <div className="mb-[12px]">
      <AccordionContainer>
        {details?.map((detailItem: MetricsDetailItem, idx) => (
          <Accordion
            key={idx + 'ai_item'}
            title={<AccordionTitle type={type} content={detailItem} index={idx + 1} tag={tag} />}
            className="mb-[12px]"
            idx={idx}
            hasNoCorrectSentence={!detailItem.sentence}
          >
            <article className="mt-[16px] text-gray-700">
              {getContent(detailItem.sentence) || null}
              {detailItem.audio_url && <AudioController src={detailItem.audio_url} id={idx} />}
              <AIParaphraseButton
                correction={detailItem.correction}
                tryCount={detailItem.corrections_count}
                highlightId={detailItem.id}
                tag={tag}
              />
            </article>
            <div
              className="flex h-[25px] cursor-pointer items-center text-[12px] font-medium tracking-wide text-gray-600 sm:text-[14px]"
              onClick={handleClickErrorReport(detailItem.id, detailItem.sentence)}
            >
              <img src={ICON_ALARM_GRAY} alt="alarm" className="mb-4" />
              <div className="ml-2 mt-1">{t(n_caf.highlight.report)}</div>
            </div>
            <ErrorReportPopupComponent
              content={sentenceToReport}
              type="highlight"
              isShowEditPopup={showPopup}
              setShowEditPopup={setShowPopup}
              id={detailItem.id}
            />
          </Accordion>
        ))}
      </AccordionContainer>
    </div>
  )
}

export default HighlightDetailListAI
